const SITE_URL = "https://www.newyeardiaries.com";

const googleReviews = [
  { name: "Mohammed Malik", rating: 5, text: "Best quality diaries and professional. They take bulk orders and name printing as well." },
  { name: "J J", rating: 5, text: "I ordered for diaries for gifting purpose, with my company name and product brochure page. It was delivered with great quality, neatly packed and was on time. Looking forward to buying again." },
  { name: "Kiran Kumar S", rating: 5, text: "Awesome diaries with better pricing and all printing, embossing, engraving work done here!" },
  { name: "Chandan G", rating: 5, text: "Best new year diaries in Bangalore for corporate gifting, reasonable pricing." },
  { name: "Maruthi Prasad", rating: 4, text: "Best quality to buy professional diaries." },
  { name: "Selvaraj Raj", rating: 5, text: "Approach for world class Eagle Diaries." },
  { name: "Rahul P R", rating: 5, text: "Good quality products." },
  { name: "Krishna Chandran", rating: 5, text: "Good service." },
];

export const organizationSchema = {
  "@context": "https://schema.org",
  "@type": "Organization",
  name: "Emcee Sons Diary House",
  alternateName: "Eagle Diaries - Emcee Sons",
  url: SITE_URL,
  logo: `${SITE_URL}/eagle_logo_cropped.png`,
  description: "Super Stockist for Eagle Diaries in Bengaluru. Premium New Year diaries, planners, journals and corporate gifts since 1976.",
  foundingDate: "1976",
  sameAs: [
    "https://www.instagram.com/newyeardiaries/",
    "https://maps.app.goo.gl/ZBNHFw3Qe1MadnTM6",
  ],
  contactPoint: {
    "@type": "ContactPoint",
    telephone: "+91-93437-16059",
    contactType: "sales",
    areaServed: "IN",
    availableLanguage: ["English", "Hindi", "Kannada"],
  },
};

export const localBusinessSchema = {
  "@context": "https://schema.org",
  "@type": "LocalBusiness",
  "@id": `${SITE_URL}/#localbusiness`,
  name: "Eagle Diaries - Emcee Sons",
  alternateName: "Emcee Sons Diary House",
  description: "Bengaluru's trusted corporate gift supplier specialising in premium New Year diaries, planners, journals, gold foiling, page insertions and fully customised diaries for bulk orders. Super Stockist for Eagle Diaries since 1976.",
  url: SITE_URL,
  telephone: "+91-93437-16059",
  email: "",
  image: `${SITE_URL}/hero_thumbnail.jpg`,
  logo: `${SITE_URL}/eagle_logo_cropped.png`,
  priceRange: "$$",
  currenciesAccepted: "INR",
  paymentAccepted: "Cash, UPI, Bank Transfer",
  foundingDate: "1976",
  address: {
    "@type": "PostalAddress",
    streetAddress: "29, Avenue Rd, inside Sri Krishna Building, opposite to SBI, Cubbonpete",
    addressLocality: "Bengaluru",
    addressRegion: "Karnataka",
    postalCode: "560002",
    addressCountry: "IN",
  },
  geo: {
    "@type": "GeoCoordinates",
    latitude: 12.972056,
    longitude: 77.5752,
  },
  openingHoursSpecification: [
    { "@type": "OpeningHoursSpecification", dayOfWeek: ["Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"], opens: "10:30", closes: "20:30" },
  ],
  aggregateRating: {
    "@type": "AggregateRating",
    ratingValue: "4.6",
    bestRating: "5",
    reviewCount: "46",
  },
  review: googleReviews.map((r) => ({
    "@type": "Review",
    author: { "@type": "Person", name: r.name },
    reviewRating: { "@type": "Rating", ratingValue: r.rating, bestRating: 5 },
    reviewBody: r.text,
  })),
  hasOfferCatalog: {
    "@type": "OfferCatalog",
    name: "Eagle Diaries 2026 Collection",
    itemListElement: [
      { "@type": "OfferCatalog", name: "Perfect Diary" },
      { "@type": "OfferCatalog", name: "Project Diary" },
      { "@type": "OfferCatalog", name: "Wings Diary" },
      { "@type": "OfferCatalog", name: "Span Diary" },
      { "@type": "OfferCatalog", name: "Club Diary" },
      { "@type": "OfferCatalog", name: "Embassy Diary" },
      { "@type": "OfferCatalog", name: "Notebooks" },
    ],
  },
};

export const websiteSchema = {
  "@context": "https://schema.org",
  "@type": "WebSite",
  name: "Eagle Diaries - Emcee Sons",
  url: SITE_URL,
  description: "Premium New Year diaries, planners, journals and corporate gifts. Gold foiling, page insertions and fully customised diaries for bulk orders.",
  publisher: { "@id": `${SITE_URL}/#localbusiness` },
};

export const faqSchema = {
  "@context": "https://schema.org",
  "@type": "FAQPage",
  mainEntity: [
    {
      "@type": "Question",
      name: "What types of customisation does Emcee Sons offer for diaries?",
      acceptedAnswer: {
        "@type": "Answer",
        text: "Emcee Sons offers three types of customisation for bulk orders: 1) Gold Foiling with company logo and personalised name, 2) Page Insertions with custom company pages, brochures, or calendars, and 3) Fully Customised Diaries designed from scratch for orders of 2000+ units — including cover material, paper quality, layout, and binding.",
      },
    },
    {
      "@type": "Question",
      name: "What is the minimum order quantity for customised diaries?",
      acceptedAnswer: {
        "@type": "Answer",
        text: "Gold foiling and page insertions are available for any bulk order quantity. Fully customised diaries (designed from scratch) require a minimum order of 2000 units. Contact us on WhatsApp at +91 93437 16059 for exact pricing.",
      },
    },
    {
      "@type": "Question",
      name: "Where is Emcee Sons located in Bengaluru?",
      acceptedAnswer: {
        "@type": "Answer",
        text: "Emcee Sons is located at 29, Avenue Road, inside Sri Krishna Building, opposite to SBI, Cubbonpete, Nagarathpete, Bengaluru, Karnataka 560002. We are open Monday to Saturday, 10:30 AM to 8:30 PM.",
      },
    },
    {
      "@type": "Question",
      name: "What diary brands does Emcee Sons stock?",
      acceptedAnswer: {
        "@type": "Answer",
        text: "Emcee Sons is the Super Stockist for Eagle Diaries, one of India's most trusted diary brands. We carry 50+ variants including Perfect Diary, Project Diary, Wings Diary, Span Diary, Club Diary, Embassy Diary, and various notebooks and planners.",
      },
    },
    {
      "@type": "Question",
      name: "How do I place a bulk order for corporate diaries?",
      acceptedAnswer: {
        "@type": "Answer",
        text: "You can place bulk orders by visiting our showroom on Avenue Road, calling us at +91 93437 16059, or messaging us on WhatsApp. We offer competitive pricing for bulk corporate orders with customisation options like gold foiling and page insertions.",
      },
    },
    {
      "@type": "Question",
      name: "Does Emcee Sons deliver diaries across India?",
      acceptedAnswer: {
        "@type": "Answer",
        text: "Yes, Emcee Sons delivers premium Eagle Diaries across India for bulk and corporate orders. Contact us on WhatsApp or phone to discuss delivery options and timelines for your location.",
      },
    },
  ],
};

export const breadcrumbSchema = (items) => ({
  "@context": "https://schema.org",
  "@type": "BreadcrumbList",
  itemListElement: items.map((item, i) => ({
    "@type": "ListItem",
    position: i + 1,
    name: item.name,
    item: item.url ? `${SITE_URL}${item.url}` : undefined,
  })),
});

export const productSchema = (product) => ({
  "@context": "https://schema.org",
  "@type": "Product",
  name: product.name,
  description: product.description,
  image: product.images.map((img) => `${SITE_URL}${img}`),
  brand: { "@type": "Brand", name: "Eagle Diaries" },
  category: product.categoryLabel,
  sku: product.id,
  size: product.size,
  offers: {
    "@type": "Offer",
    availability: "https://schema.org/InStock",
    priceCurrency: "INR",
    seller: { "@id": `${SITE_URL}/#localbusiness` },
    url: `${SITE_URL}/shop/${product.id}`,
  },
  aggregateRating: {
    "@type": "AggregateRating",
    ratingValue: "4.6",
    bestRating: "5",
    reviewCount: "46",
  },
});

export const itemListSchema = (products) => ({
  "@context": "https://schema.org",
  "@type": "ItemList",
  name: "Eagle Diaries 2026 Collection",
  description: "Complete range of premium New Year diaries, planners and notebooks by Eagle Diaries",
  numberOfItems: products.length,
  itemListElement: products.map((p, i) => ({
    "@type": "ListItem",
    position: i + 1,
    name: p.name,
    url: `${SITE_URL}/shop/${p.id}`,
    image: `${SITE_URL}${p.images[0]}`,
  })),
});
